import { resolveComponent as h, openBlock as l, createElementBlock as a, normalizeClass as y, createElementVNode as x, createTextVNode as D, toDisplayString as p, createVNode as d, createCommentVNode as o, resolveDirective as k, withDirectives as _, withKeys as v, vModelText as E, Transition as N, withCtx as u, Fragment as T, renderList as V, createBlock as f, renderSlot as b } from "vue";
import { _ as I } from "./_plugin-vue_export-helper-dad06003.js";
import { C as L } from "./CheckIcon-91388c05.js";
import { H } from "./HelpIcon-2069ddad.js";
import { C as F } from "./ChevronDownIcon-461d1eb9.js";
import { D as M } from "./DropdownTextDivider-98e5ec60.js";
import { _ as U } from "./CardVideo-d193ca09.js";
import { _ as W } from "./SlideDownTransition-6bc064ec.js";
import { useNotificationHandler as K } from "./useNotificationHandler.js";
const z = {
  components: {
    CheckIcon: L
  },
  props: {
    option: {
      type: Object,
      default: () => ({})
    },
    selected: Boolean,
    highlighted: Boolean
  },
  emits: ["select"],
  methods: {
    select() {
      this.$emit("select", this.option.value);
    }
  }
}, A = { class: "pl-2 font-normal ct-text-3" }, j = {
  key: 0,
  class: "ct-fg-1 absolute inset-y-0 right-0 flex items-center pr-4"
};
function P(e, n, t, w, r, s) {
  const g = h("CheckIcon");
  return l(), a("div", {
    class: y(["cursor-pointer select-none relative py-2 pl-3 pr-9", {
      "text-gray-800 dark:text-neutral-200 bg-gray-50 dark:bg-neutral-800": t.highlighted,
      "ct-text-2 group-hover:ct-text-2--hover": !t.highlighted
    }]),
    onClick: n[0] || (n[0] = (...c) => s.select && s.select(...c))
  }, [
    x("p", {
      class: y(["block truncate font-medium text-base", { "ct-text-2": !t.selected, "ct-text-1": t.selected }])
    }, [
      D(p(t.option.label) + " ", 1),
      x("span", A, p(t.option.info), 1)
    ], 2),
    t.selected ? (l(), a("span", j, [
      d(g, { class: "h-5 w-5" })
    ])) : o("", !0)
  ], 2);
}
const q = /* @__PURE__ */ I(z, [["render", P]]), G = {
  components: {
    ChevronDownIcon: F,
    HelpIcon: H,
    SelectOption: q,
    DropdownTextDivider: M
  },
  props: {
    label: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    tooltip: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: [String, Number],
      default: ""
    },
    hasWarning: Boolean,
    disabled: Boolean,
    isInvalid: Boolean,
    transparent: Boolean,
    searchEnabled: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["input", "change"],
  data() {
    return {
      selfValue: this.value,
      expanded: !1,
      search: "",
      selectedIndex: 0
    };
  },
  computed: {
    firstIndex() {
      return this.availableOptions.findIndex((e) => !e.isDivider);
    },
    lastIndex() {
      return this.availableIndexes.findLast((e) => e !== null);
    },
    availableIndexes() {
      return this.availableOptions.map((e, n) => e.isDivider ? null : n);
    },
    selectedLabel() {
      if (this.value === void 0)
        return null;
      const e = this.options.find((n) => n.value == this.value);
      return e ? e.label : null;
    },
    availableOptions() {
      return this.search ? this.options.filter(
        (e) => !e.isDivider && String(e.label).toLowerCase().includes(this.search.toLowerCase())
      ) : this.options;
    }
  },
  watch: {
    expanded(e) {
      e && this.searchEnabled ? this.$nextTick(() => {
        this.$refs.searchInput.focus();
      }) : this.search = "";
    },
    availableOptions() {
      this.selectedIndex = 0;
    }
  },
  mounted() {
    this.selectedIndex = this.firstIndex;
  },
  methods: {
    hide(e) {
      e && e.stopImmediatePropagation(), this.expanded = !1;
    },
    show() {
      this.disabled || (this.expanded = !0);
    },
    select(e) {
      this.$emit("input", e), this.$emit("change", e), this.hide();
    },
    selectCurrentOption() {
      const e = this.availableOptions[this.selectedIndex];
      this.select(e ? e.value : null);
    },
    moveIndexUp() {
      let e = [...this.availableIndexes].reverse().find((n) => n < this.selectedIndex && n !== null);
      e === void 0 && (e = this.firstIndex), this.selectedIndex = Math.max(e, this.firstIndex), this.scrollList();
    },
    moveIndexDown() {
      let e = this.availableIndexes.find((n) => n > this.selectedIndex);
      e === void 0 && (e = this.lastIndex), this.selectedIndex = Math.min(e, this.lastIndex), this.scrollList();
    },
    scrollList() {
      const e = this.$refs.option[this.selectedIndex];
      e && e.scrollIntoView({
        block: "nearest"
      });
    }
  }
}, J = { class: "flex items-center relative" }, Q = {
  key: 0,
  class: "mr-2 text-sm font-medium ct-text-1"
}, R = { class: "w-full relative rounded-lg shadow-sm shadow-gray-900/5" }, X = {
  key: 0,
  class: "block truncate"
}, Y = ["placeholder"], Z = { class: "absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none" }, $ = {
  key: 2,
  class: "absolute inset-y-0 right-4 pr-3 flex items-center"
}, ee = {
  key: 0,
  ref: "list",
  class: "ct-bg-1--alt absolute top-full z-10 mt-1 w-full shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm"
};
function te(e, n, t, w, r, s) {
  const g = h("ChevronDownIcon"), c = h("HelpIcon"), m = h("DropdownTextDivider"), C = h("SelectOption"), O = k("tooltip"), B = k("click-outside");
  return l(), a("div", J, [
    t.label ? (l(), a("label", Q, p(t.label), 1)) : o("", !0),
    x("div", R, [
      x("div", {
        class: y(["ct-input--select", {
          "is-disabled": t.disabled,
          "is-error": t.isInvalid,
          "is-warning": t.hasWarning
        }]),
        onClick: n[5] || (n[5] = (...i) => s.show && s.show(...i))
      }, [
        !t.searchEnabled || !r.expanded ? (l(), a("span", X, p(s.selectedLabel || t.title || "Select"), 1)) : o("", !0),
        r.expanded && t.searchEnabled ? _((l(), a("input", {
          key: 1,
          ref: "searchInput",
          "onUpdate:modelValue": n[0] || (n[0] = (i) => r.search = i),
          class: "block w-full border-0 p-0 ct-text-1 placeholder:ct-text-placeholder focus:ring-0 text-base bg-transparent",
          type: "text",
          placeholder: t.placeholder,
          onKeydown: [
            n[1] || (n[1] = v((...i) => s.moveIndexUp && s.moveIndexUp(...i), ["up"])),
            n[2] || (n[2] = v((...i) => s.moveIndexDown && s.moveIndexDown(...i), ["down"]))
          ],
          onKeyup: [
            n[3] || (n[3] = v((...i) => s.selectCurrentOption && s.selectCurrentOption(...i), ["enter"])),
            n[4] || (n[4] = v((...i) => s.hide && s.hide(...i), ["esc"]))
          ]
        }, null, 40, Y)), [
          [E, r.search]
        ]) : o("", !0),
        x("span", Z, [
          d(g, {
            class: y(["h-5 w-5 transform transition-transform", {
              "text-white": !t.isInvalid && t.transparent,
              "text-gray-400": !t.isInvalid && !t.transparent,
              "text-red-300": t.isInvalid,
              "rotate-180": r.expanded
            }])
          }, null, 8, ["class"])
        ]),
        t.tooltip ? (l(), a("div", $, [
          _(d(c, { class: "h-5 w-5 text-gray-400 cursor-help" }, null, 512), [
            [O, { content: t.tooltip, autoHide: !1, html: !0 }]
          ])
        ])) : o("", !0)
      ], 2)
    ]),
    d(N, {
      "enter-active-class": "transition ease-out duration-150",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "transition ease-in duration-150",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: u(() => [
        r.expanded && s.availableOptions.length ? _((l(), a("ul", ee, [
          (l(!0), a(T, null, V(s.availableOptions, (i, S) => (l(), a("li", {
            key: i.value,
            ref_for: !0,
            ref: "option"
          }, [
            i.isDivider ? (l(), f(m, { key: 0 }, {
              default: u(() => [
                D(p(i.label), 1)
              ]),
              _: 2
            }, 1024)) : (l(), f(C, {
              key: 1,
              option: i,
              selected: t.value == i.value,
              highlighted: t.searchEnabled && r.selectedIndex === S,
              onMouseenter: (de) => r.selectedIndex = S,
              onSelect: s.select
            }, null, 8, ["option", "selected", "highlighted", "onMouseenter", "onSelect"]))
          ]))), 128))
        ])), [
          [B, { handler: s.hide, capture: !0 }]
        ]) : o("", !0)
      ]),
      _: 1
    })
  ]);
}
const ne = /* @__PURE__ */ I(G, [["render", te]]), se = {
  components: {
    SearchableSelect: ne,
    FormNotification: U,
    SlideDownTransition: W
  },
  props: {
    label: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "Search..."
    },
    tooltip: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: [String, Number],
      default: ""
    },
    help: {
      type: String,
      default: ""
    },
    warning: {
      type: String,
      default: ""
    },
    success: {
      type: String,
      default: ""
    },
    error: {
      type: String,
      default: ""
    },
    disabled: Boolean,
    transparent: Boolean,
    searchEnabled: {
      type: Boolean,
      default: !0
    },
    modelValue: {
      type: [String, Number],
      default: ""
    }
  },
  emits: ["update:modelValue", "input", "change"],
  setup(e) {
    return K(e);
  },
  methods: {
    select(e) {
      this.$emit("input", e), this.$emit("change", e), this.$emit("update:modelValue", e);
    }
  }
}, le = { "data-scroll": "" }, ie = {
  key: 0,
  class: "flex items-center text-sm font-medium leading-6 ct-text-2 space-x-1 mb-2"
}, ae = {
  key: 1,
  class: "mb-2 text-sm ct-text-3"
}, oe = {
  key: 2,
  class: "mt-2 text-sm ct-text-3"
};
function re(e, n, t, w, r, s) {
  const g = h("SearchableSelect"), c = h("FormNotification"), m = h("SlideDownTransition");
  return l(), a("div", le, [
    t.label ? (l(), a("div", ie, p(t.label), 1)) : o("", !0),
    e.$slots.description ? (l(), a("div", ae, [
      b(e.$slots, "description")
    ])) : o("", !0),
    d(g, {
      value: t.value,
      title: t.title,
      placeholder: t.placeholder,
      disabled: t.disabled,
      transparent: t.transparent,
      "is-invalid": e.hasError,
      "has-warning": e.hasWarning,
      "search-enabled": t.searchEnabled,
      tooltip: t.tooltip,
      options: t.options,
      onInput: s.select
    }, null, 8, ["value", "title", "placeholder", "disabled", "transparent", "is-invalid", "has-warning", "search-enabled", "tooltip", "options", "onInput"]),
    t.options.length < 2 && e.$slots.empty ? (l(), a("p", oe, [
      b(e.$slots, "empty")
    ])) : o("", !0),
    d(m, { speed: 0.25 }, {
      default: u(() => [
        e.hasHelp ? (l(), f(c, {
          key: 0,
          message: t.help,
          help: ""
        }, {
          default: u(() => [
            b(e.$slots, "help")
          ]),
          _: 3
        }, 8, ["message"])) : o("", !0)
      ]),
      _: 3
    }),
    d(m, { speed: 0.25 }, {
      default: u(() => [
        e.hasError ? (l(), f(c, {
          key: 0,
          message: t.error,
          error: ""
        }, {
          default: u(() => [
            b(e.$slots, "error")
          ]),
          _: 3
        }, 8, ["message"])) : o("", !0)
      ]),
      _: 3
    }),
    d(m, { speed: 0.25 }, {
      default: u(() => [
        e.hasWarning ? (l(), f(c, {
          key: 0,
          message: t.warning,
          "inner-classes": "mt-2 text-sm ct-text-warning"
        }, null, 8, ["message"])) : o("", !0)
      ]),
      _: 1
    }),
    d(m, { speed: 0.25 }, {
      default: u(() => [
        e.hasSuccess ? (l(), f(c, {
          key: 0,
          message: t.success,
          "inner-classes": "mt-2 text-sm ct-text-success"
        }, null, 8, ["message"])) : o("", !0)
      ]),
      _: 1
    })
  ]);
}
const be = /* @__PURE__ */ I(se, [["render", re]]);
export {
  be as F,
  q as S
};
